import SinggahsiniInfo from './SinggahsiniInfo.vue';

export default SinggahsiniInfo;
